import { Stack, styled } from "@mui/material";
import { ComponentProps, FC } from "react";
import { InternalButtonLink } from "../InternalButtonLink";
export {
    BannerWrapper,
    ButtonContainer,
    HeadingContainer,
    HighlightedText,
    ImageContainer,
    InlineText,
} from "./BannerCommon.styled";

export const ContentContainer = styled(Stack)(() => ({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
}));

export const StyledButton: FC<Omit<ComponentProps<typeof InternalButtonLink>, "variant" | "size">> = (props) => (
    <InternalButtonLink variant="contained" size="medium" {...props} />
);
